export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'error',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      redirectIfLoggedIn: true,
    },
  },
  // LAUNCH LATER: Uncomment when documentation module launches (public candidate upload page).
  // {
  //   path: '/documentation/:token',
  //   name: 'public-documentation',
  //   component: () => import('@/views/public/PublicDocumentationPage.vue'),
  //   meta: {
  //     layout: 'full',
  //     resource: 'auth',
  //     action: 'read',
  //   },
  // },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    resource: 'auth',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  // {
  //   path: '/pages/miscellaneous/policy-documents',
  //   name: 'policy-documents',
  //   component: () => import('@/views/pages/miscellaneous/PolicyDocuments.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  {
    path: '/pages/miscellaneous/policy-documents',
    name: 'policy-documents',
    resource: 'policy-docs',
    component: () => import('@/views/pages/miscellaneous/PolicyDocuments.vue'),
    meta: {
      pageTitle: 'Policy Documents',
      // resource: 'policy-docs',
      breadcrumb: [
        {
          text: 'Policy Documents',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'reset_password',
      action: 'read',
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      resource: "profile",
      action: 'read',
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],  
    },
  },
]
